module.exports = __webpack_public_path__ + "img/kort-23.82339431.jpg";